import { DAYS } from "@/lib/formSchema";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { cn } from "@/lib/utils";

interface TimeAvailabilityProps {
  value: string[];
  onChange: (value: string[]) => void;
  className?: string;
}

export function TimeAvailability({ value, onChange, className }: TimeAvailabilityProps) {
  const toggleDay = (day: string) => {
    if (value.includes(day)) {
      onChange(value.filter((d) => d !== day));
    } else {
      onChange([...value, day]);
    }
  };

  return (
    <div className={cn("space-y-4", className)}>
      <Label className="text-base font-medium">Days Available</Label>
      <p className="text-sm text-muted-foreground">
        Select all days you&apos;re available for mentoring sessions
      </p>
      <div className="space-y-2">
        {DAYS.map((day) => {
          const isWeekend = day === "Saturday" || day === "Sunday";
          const timeLabel = isWeekend ? "11am – 6pm" : "5 – 9pm";
          const isChecked = value.includes(day);

          return (
            <div key={day} className="flex items-center space-x-3">
              <Checkbox
                id={day}
                checked={isChecked}
                onCheckedChange={() => toggleDay(day)}
              />
              <label htmlFor={day} className="text-sm cursor-pointer">
                {day}{" "}
                <span className="text-muted-foreground">({timeLabel})</span>
              </label>
            </div>
          );
        })}
      </div>
      {value.length > 0 && (
        <p className="text-sm text-muted-foreground">
          {value.length} day{value.length !== 1 ? "s" : ""} selected
        </p>
      )}
    </div>
  );
}
